<template>
    <div>
        <h3 class="ut-text-lg ut-mb-4">Corelogic History</h3>

        <div class="timeline ut-ml-4">
            <div v-for="(history, i) in listingHistory" :key="i" class="timelineitem">
                <div v-if="limit === 0|| limit >= (i+1) ">
                    <div class="circle">&nbsp;</div>
                    <div class="line"></div>
                    <div class="listing-date">{{history.sortBy}}</div>
                    <div class="listing-info">{{history.listingInfo}}
                        <span v-if="history.listingAgency"> - {{history.listingAgency}}</span>
                    </div>
                </div>

            </div>
        </div>

        <div class="ut-mt-6 timeline-footer">
           <span> Data provided by</span> <span>
            <img src="@/assets/images/corelogic.png" />
            </span>
        </div>

    </div>
</template>

<script>
export default {
  name: 'CoreLogicHistory',
  props: {
    listingHistory: {
      required: true,
    },
    limit: {
      default: 0,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">

    .timeline-footer {
        img {
            width: 110px;
            padding: 5px 10px 10px;
            vertical-align: middle;
        }
    }
    .timelineitem{
        @apply ut-relative;
    }
    .circle {
        border-width: 5px;
        @apply ut-border-green-400;
        background-color: white;
        width: 13px;
        height: 13px;
        overflow: hidden;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        border-radius: 50%;
        /*display: inline-block;*/
        vertical-align: middle;
        margin: auto 20px auto 0;
        position: relative;
    }

    .line {
        margin: auto;
        height: 54px;
        width: 1px;
        background-color: #aab2b9;
        display: block;
        margin-left: 6px;
    }

    .listing-date {
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        top: -4px;
        right: 0;
        left: 25px;
        bottom: 0;
        color: #000000;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 1.25px;
        line-height: 18px;
    }

    .listing-info{
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        top: 14px;
        right: 0;
        left: 25px;
        bottom: 0;
        color: #2E343B;
        font-size: 14px;
        line-height: 22px;
    }

    .timeline-footer{
        opacity: 0.8;
        color: #2E343B;
        font-size: 12px;
        line-height: 20px;
    }

</style>
